export default "__VITE_ASSET__4e46da67__"